"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const QuestionAnswerOption_1 = require("../Model/Question/QuestionAnswerOption");
class QuestionAnswerOptionToDataTransformer {
    /**
     * @inheritDoc
     */
    to(answer) {
        // Implement when needed.
        return {};
    }
    /**
     * @inheritDoc
     */
    from(data) {
        return new QuestionAnswerOption_1.default()
            .setLabel(data.label)
            .setDescription(data.description)
            .setWeight(data.weight || 0)
            .setValue(data.value)
            .setOptions(data.options);
    }
}
exports.default = QuestionAnswerOptionToDataTransformer;
